import { createAction } from 'Utility/Redux';
import { AnyBoosterType } from './BoosterType';

enum Types {
    PLAY_CARD = 'playCard',
    PLAY_BOOSTER = 'playBooster',
    PLAY_REMOVE_THREE_PRE_BOOSTER = 'playRemoveThreePreBooster',
    SET_CARD_IN_STACK_BY_INDEX = 'setCardInStackByIndex',
    DISCARD_CARDS = 'discardCards',
}

export const CardActions = {
    playCard: createAction(Types.PLAY_CARD, resolve => (cardID: string) =>
        resolve<string>(cardID)
    ),

    playBooster: createAction(
        Types.PLAY_BOOSTER,
        resolve => (type: AnyBoosterType) => resolve(type)
    ),


    setCardInStackByIndex: createAction(
        Types.SET_CARD_IN_STACK_BY_INDEX,
        resolve => (cardId: string, index: number) => resolve(cardId, index)
    ),

    discardCards: createAction(
        Types.DISCARD_CARDS,
        resolve => (cardIDs: string[]) => resolve(cardIDs)
    ),
};
